<template>
    <v-list dense class="kp-context-menu">
        <!-- Download -->
        <v-list-item dense :href="getUrl(true)" target="_blank" rel="noreferrer noopener">
            <v-list-item-icon>
                <v-icon>ic ic-20 ic-preview ic-col-grey</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ $t('download') }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <!-- Delete -->
        <v-list-item dense @click="$emit('delete', record)">
            <v-list-item-icon>
                <v-icon>ic ic-20 ic-trash ic-col-grey</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ $t('delete') }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <!-- Duplicate -->
        <v-list-item dense @click="$emit('duplicate', record)">
            <v-list-item-icon>
                <v-icon>ic ic-20 ic-copy ic-col-grey</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ $t('duplicate') }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</template>

<script>
import { Image } from '@/models/Image';

export default {
    name: 'MediaManagerImageContextMenu',

    props: {
        record: {
            type: Image,
            default: () => null,
        },
    },

    methods: {
        getUrl() {
            return this.record.url;
        },
    },
};
</script>
